import {
  dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
  dimensiondata_2_termekek_group_dimension_1_column,
  dimensiondata_2_termekek_group_column,
  TJ_NCV_netto_value_1_precision,
  TJ_GCV_value_2_data_precision,
  year_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const evesFoldgazMerlegConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: true,
  filterYear: {numberOfYears: 12},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/EvesFoldgazMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_1_2_3_4_5_group_w200_row,
      year_column,
     
      TJ_NCV_netto_value_1_precision,
      TJ_GCV_value_2_data_precision,
      order_1,
      order_2
    ],
  },
};

// ...dimensiondata_2_termekek_group_dimension_1_column,
//       ...dimensiondata_2_termekek_group_column,
